"use client";

import React, { useState, useEffect } from "react";
import {
  Select,
  SelectItem,
  NumberInput,
  Switch,
  Tooltip,
} from "@tremor/react";
import CakeTiers from "./CakeTiers";

const ClientCakeCalculator = ({
  showPrice = false,
  showMostPopular = false,
}) => {
  const [combinations, setCombinations] = useState([]);
  const [type, setType] = useState("round");
  const [servings, setServings] = useState(120);
  const [servingSize, setServingSize] = useState("1x2");
  const [occasion, setOccasion] = useState("wedding");
  const [mostPopular, setMostPopular] = useState(true);
  const [customise, setCustomise] = useState(false);

  const handleSwitchChange = (value) => {
    setMostPopular(!value);
    setCustomise(value);
  };

  useEffect(() => {
    if (servings > 0) {
      fetch(
        `/api/cake-calculator?type=${type}&servings=${servings}&servingSize=${servingSize}&occasion=${occasion}&show_price=${showPrice}&most_popular=${mostPopular}`
      )
        .then((response) => response.json())
        .then((data) => {
          setCombinations(data.combinations);
        })
        .catch((error) => console.error("Error:", error));
    }
  }, [
    type,
    servings,
    servingSize,
    occasion,
    showPrice,
    mostPopular,
    customise,
  ]);

  return (
    <div className="w-full min-w-full transform transition-all duration-300 ease-in-out">
      <div className="bg-white text-gray-800 p-4  w-full text-md mb-24">
        <p>
          Select your <strong>occasion</strong>, <strong> cake type</strong>,{" "}
          {""}
          <strong>number of people</strong> and <strong> serving size</strong> .
          The calculator will recommend the best cake tiers based on your number
          of guests.
          <br />
          <strong> Enable Customisation</strong> to manually adjust tiers and
          sizes.
        </p>
      </div>
      <div className="min-100 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
        <div className="flex-none h-14 mr-2">
          <label className="block">
            <span className="block text-sm font-medium text-slate-700 text-left">
              Occasion
            </span>
            <Select
              value={occasion}
              onValueChange={setOccasion}
              placeholder="Occasion"
              enableClear={false}
              disabled={!customise}
              onClick={(event) => event.preventDefault()}
            >
              <SelectItem value="celebration">Celebration</SelectItem>
              <SelectItem value="wedding">Wedding</SelectItem>
            </Select>
          </label>
        </div>
        <div className="flex-none h-14 mr-2">
          <label className="block">
            <span className="block text-sm font-medium text-slate-700 text-left">
              Cake Type
            </span>
            <Select
              value={type}
              onValueChange={setType}
              placeholder="Cake Type"
              enableClear={false}
              disabled={!customise}
              onClick={(event) => event.preventDefault()}
            >
              <SelectItem value="round">Round</SelectItem>
              <SelectItem value="square">Square</SelectItem>
            </Select>
          </label>
        </div>
        <div className="flex-none w-29 mr-2">
          <label className="block">
            <span className="block text-sm font-medium text-slate-700 text-left">
              Number of people
            </span>
            <NumberInput
              defaultValue={servings}
              disabled={!customise}
              onChange={(e) => setServings(parseInt(e.target.value, 10) || 6)}
              placeholder="Disabled"
              min={6}
              max={272}
            />
          </label>
        </div>
        <div className="flex-none w-50 mr-2">
          <label className="block">
            <span className="block text-sm font-medium text-slate-700 text-left">
              Serving size
            </span>
            <Select
              value={servingSize}
              disabled={!customise}
              onValueChange={setServingSize}
              placeholder="Cake Type"
              enableClear={false}
              onClick={(event) => event.preventDefault()}
            >
              <SelectItem value="1x1">1x1 inches</SelectItem>
              <SelectItem value="1x2">1x2 inches</SelectItem>
            </Select>
          </label>
        </div>
        {showMostPopular && (
          <div className="flex-none col-span-2 md:col-span-1 lg:col-span-1">
            <div className="flex items-center space-x-3 pt-7">
              <Switch
                id="switch"
                name="switch"
                checked={customise}
                onChange={handleSwitchChange}
              />

              <label
                htmlFor="switch"
                className="text-sm text-gray-500"
                data-tooltip-target="tooltip-default"
              >
                Enable Customisation
              </label>
            </div>
          </div>
        )}
      </div>
      <div className="max-w-sm mx-auto space-y-6 mt-20"></div>
      <CakeTiers
        combinations={combinations}
        type={type}
        servingSize={servingSize}
        showPrice={showPrice}
      />
      {combinations.length === 0 && (
        <div className="items-center justify-between font-mono text-sm">
          <div className="text-center text-slate-500">
            <div className="">No combination found</div>
            <div className="text-sm">Please try with different options</div>
          </div>
        </div>
      )}
      {!customise && combinations.length > 0 && (
        <div className="max-w-sm mx-auto space-y-6 mb-20 text-2xl font-serif font-normal">
          Most Popular Sizes
        </div>
      )}
    </div>
  );
};

export default ClientCakeCalculator;
